import SubcategoryPage from '@/components/template/SubcategoryPage';

const TuaregVases = () => {
  const products = [
    {
      title: "Tuareg Vase Small",
      imageSrc: "https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&q=80",
      url: "/proizvodi/tuareg-vase-small"
    },
    {
      title: "Tuareg Vase Medium",
      imageSrc: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&q=80",
      url: "/proizvodi/tuareg-vase-medium"
    },
    {
      title: "Tuareg Vase Large",
      imageSrc: "https://images.unsplash.com/photo-1586198532065-b3a32857c5c4?auto=format&fit=crop&q=80",
      url: "/proizvodi/tuareg-vase-large"
    }
  ];

  return (
    <SubcategoryPage
      title="Tuareg Vases"
      description="Ročno izdelane Tuareg vaze, navdihnjene s tradicijo nomadskih ljudstev, prinašajo edinstven kos umetniškega dela v vaš dom."
      heroImage="https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default TuaregVases;